import { Company } from '@models';

export interface AllOrganizationsResult {
  organizations: Company[];
}
